
import trim from 'lodash/trim'
import Cookies from 'js-cookie'

export const USER_LANG = Cookies.get('_zm_lang') || 'en-US'

/**
 * This function contains code that was transferred from the "fe-billing-web/src/common/util"
 */
export const separatorConfig = {
  'en-US': { decimal: '.', commaStyle: ',', place: 'begin', space: false },
  'en-GB': { decimal: '.', commaStyle: ',', place: 'begin', space: false },
  'zh-CN': { decimal: '.', commaStyle: ',', place: 'end', space: true, specialSymbol: true },
  'es-ES': { decimal: ',', commaStyle: '.', place: 'end', space: true },
  'fr-FR': { decimal: ',', commaStyle: ' ', place: 'end', space: true },
  'jp-JP': { decimal: '.', commaStyle: ',', place: 'begin', space: true },
  'de-DE': { decimal: ',', commaStyle: '.', place: 'end', space: true },
  'pt-PT': { decimal: ',', commaStyle: '.', place: 'begin', space: true },
  'ru-RU': { decimal: ',', commaStyle: ' ', place: 'end', space: true, specialSymbol: true },
  'zh-TW': { decimal: '.', commaStyle: ',', place: 'end', space: true, specialSymbol: true },
  'ko-KO': { decimal: '.', commaStyle: ',', place: 'begin', space: false },
  'it-IT': { decimal: ',', commaStyle: '.', place: 'begin', space: true },
  'vi-VN': { decimal: ',', commaStyle: '.', place: 'begin', space: true }
}

/**
 * This function contains code that was transferred from the "fe-billing-web/src/common/util"
 * @param {String: en-US | en-GB | zh-CN | zh-TW | es-ES | jp-JP | de-DE | pt-PT | ru-RU | ko-KO | it-IT | vi-VN } language
 *
 */
export const getDecimalSeparatorConfig = (language) => {
  return separatorConfig[language] || { decimal: '.', commaStyle: ',', place: 'begin', space: false }
}
/**
 * This const contains code that was transferred from the "fe-billing-web/src/common/util"
 */
export const UserSeparator = getDecimalSeparatorConfig(USER_LANG)

export const compareStringsIgnoreCase = (str1, str2) => {
  const _str1 = str1.toLocaleLowerCase()
  const _str2 = str2.toLocaleLowerCase()
  return _str1 === _str2
}

export const extractFirstNumberFromString = (string) => {
  try {
    const matches = string.match(/\d+/)
    if (matches && matches.length > 0) {
      return parseInt(matches[0], 10)
    }
  } catch (e) {
    console.error(`Error parsing string to find first number: ${string}: `, e)
  }
  return null
}

export function stringHasNumber(str) {
  return /\d/.test(str)
}

export const isBlank = (string) => !string || trim(string) === ''
